import React from "react";
import * as Icon from "react-feather";
import clsx from "clsx";
import { formatAmount } from "./helpers/formatters";
import { WP_REF_BY_CATEGORY } from "./helpers/constants";
import "../afs-walkthrough.css";
import ToolsInlineEdit from "../../kit/ToolsInlineEdit";
import AFSService from "../../../../../services/AFSService";
import WComponent from "../../../../common/WComponent";

const fmt = formatAmount;

class SectionRows extends WComponent {
	render() {
	let { section, expanded, onToggle, showComparatives, show2022, onDrillAccount, onDrillLines, onNavigateToLeadSheet, onMoveAccount, onRenameAccount, accountCaptions, onSortSection, sectionSortOrder } = this.props;
	const onOpenSectionTotal = event => {
		event.stopPropagation();
		onDrillLines(AFSService.describeLinesToOpen({ title: section.name, accounts: section.accounts, current: section.totalCurrent, prior: section.totalPrior }));
	};
	const hasSeveralLines = (section.accounts || []).length > 1;
	const canBeReordered = !!onMoveAccount && hasSeveralLines;
	const canBeSorted = !!onSortSection && hasSeveralLines;
	const orderInForce = (sectionSortOrder || {})[section.category] || "entered";

	const sortChoices = [
		{ order: "entered", label: "As entered", title: "Leave the lines in the order the accounts come out in" },
		{ order: "alphabetical", label: "A–Z", title: "Sort this section alphabetically" },
		{ order: "largest", label: "Largest", title: "Sort this section largest amount first" },
	];
	if (orderInForce === "custom") sortChoices.push({ order: "custom", label: "Custom", title: "You arranged these lines by hand" });
	const isExpanded = expanded.has(section.name);
	const wpRef = section.category ? WP_REF_BY_CATEGORY[section.category] : null;
	const wpRefClickable = Boolean(wpRef && onNavigateToLeadSheet);
	return (
		<>
			<tr className={clsx("afs-fs-table__section-row", isExpanded && "afs-fs-table__section-row--expanded")} onClick={() => onToggle(section.name)}>
				<td className="afs-fs-table__section-name">
					<span className="afs-fs-table__section-chevron-wrap">
						{isExpanded
							? <Icon.ChevronDown size={13} color="#7a90c0" />
							: <Icon.ChevronRight size={13} color="#b0b8d0" />}
						{section.name}
					</span>
					{canBeSorted && (
						<span className="afs-fs-table__sort" onClick={(e) => e.stopPropagation()}>
							{sortChoices.map(choice => (
								<button
									key={choice.order}
									type="button"
									className={clsx("afs-fs-table__sort-button", orderInForce === choice.order && "afs-fs-table__sort-button--active")}
									title={choice.title}
									onClick={() => onSortSection({ section, order: choice.order })}
								>
									{choice.label}
								</button>
							))}
						</span>
					)}
				</td>
				<td
					className={clsx("afs-fs-table__wp-ref-cell", wpRefClickable && "afs-fs-table__wp-ref-cell--clickable")}
					onClick={wpRefClickable ? (e) => { e.stopPropagation(); onNavigateToLeadSheet(wpRef); } : undefined}
				>
					{wpRef || ""}
				</td>
				<td className="afs-fs-table__section-amt afs-drillable" onClick={onOpenSectionTotal}>{fmt(section.totalCurrent)}</td>
				{showComparatives && <td className="afs-fs-table__section-amt afs-drillable" onClick={onOpenSectionTotal}>{fmt(section.totalPrior)}</td>}
				{show2022 && <td className="afs-fs-table__section-amt afs-fs-table__account-amt--faded">{fmt(section.totalPriorPrior)}</td>}
			</tr>
			{isExpanded && section.accounts.map((acct, i) => (
				<tr
					key={i}
					className="afs-fs-table__account-row afs-drillable"
					onClick={() => onDrillAccount(acct)}
				>
					<td className="afs-fs-table__account-name">
						{onRenameAccount ? (
							<span className="afs-fs-table__account-caption" onClick={(e) => e.stopPropagation()}>
								<ToolsInlineEdit
									label="the wording of this line"
									value={(accountCaptions || {})[acct.canonical_code] || ""}
									displayValue={acct.description}
									placeholder={acct.description}
									onChange={({ value }) => onRenameAccount({ account: acct, caption: value })}
								/>
							</span>
						) : acct.description}
						{canBeReordered && (
							<span className="afs-fs-table__reorder">
								<button
									type="button"
									className="afs-fs-table__reorder-button"
									title="Move this line up"
									disabled={i === 0}
									onClick={(e) => { e.stopPropagation(); onMoveAccount({ section, account: acct, direction: "up" }); }}
								>
									<Icon.ChevronUp size={13} />
								</button>
								<button
									type="button"
									className="afs-fs-table__reorder-button"
									title="Move this line down"
									disabled={i === section.accounts.length - 1}
									onClick={(e) => { e.stopPropagation(); onMoveAccount({ section, account: acct, direction: "down" }); }}
								>
									<Icon.ChevronDown size={13} />
								</button>
							</span>
						)}
					</td>
					<td className="afs-fs-table__wp-ref-cell" />
					<td className="afs-fs-table__account-amt">{fmt(acct.current)}</td>
					{showComparatives && <td className="afs-fs-table__account-amt">{fmt(acct.prior)}</td>}
					{show2022 && <td className="afs-fs-table__account-amt afs-fs-table__account-amt--faded">{fmt(acct.priorPrior)}</td>}
				</tr>
			))}
		</>
	);
	}
}

export default SectionRows;
